import { render } from "./DaftarAlbum.vue?vue&type=template&id=549da98e"
import script from "./DaftarAlbum.vue?vue&type=script&lang=js"
export * from "./DaftarAlbum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__